import formation from './formation'
import ftabs from './ftabs'
import fmodal from './fmodal'
import fselect from './fselect'

export default {
  formation,
  ftabs,
  fmodal,
  fselect
}



/** WEBPACK FOOTER **
 ** ./src/docs/index.js
 **/